import * as utils from './utils';

/**
* In the components.ts functions to create all the components in the framework from js should exist.
*/
export class Components {
    constructor() {
        this.types = ['accordion'];
    }

    /**
    * createAccordionHtml creates html for the accordion component
    * @param {object} o options
    * @example createAccordionHtml({objects: [{title:'Collapsible Group1', content:'lorem ipsum1'},{title:'Collapsible Group2', content:'lorem ipsum2'} ]})
    * @return {{}|undefined} undefined if no component was created (with console message) or a object where the html is in o.html
    */
    createAccordionHtml(o) {
        o = typeof o === 'undefined' ? {} : o;
        o.objects = typeof o.objects === 'undefined' ? {} : o.objects;
        o.allowManyOpen = typeof o.allowManyOpen === 'undefined' ? false : o.allowManyOpen;

        if (o.objects.length === undefined || o.objects.length === 0) {
            console.log('createAccordionHtml called with not correct parameters or to few objects, return undefined', o);
            return undefined;
        }

        var idComponent = utils.getUniqueComponentId({ prefix: 'accordion-' });

        var componentContent = '';
        for (var i = 0, nr = o.objects.length; i < nr; i++) {
            var object = o.objects[i];

            var randId = utils.getUniqueComponentId({ prefix: 'collapse-' });
            var shouldBeAbleToHaveSeveralGroupsOpenAtTheSameTimeHtml = o.allowManyOpen === false ? ' data-parent="' + idComponent + '"' : '';
            var isExpanded = typeof object.isExpanded !== "undefined" && object.isExpanded === true ? true : false;
            var isExpandedHeaderHtml = isExpanded ? '' : ' class="collapsed"';
            var isExpandedHtml = isExpanded ? ' in' : '';
            componentContent +=
                '<div class="panel panel-default">' +
                '    <div class="panel-heading">' +
                '        <h4 class="panel-title"><a data-toggle="collapse"' + isExpandedHeaderHtml + shouldBeAbleToHaveSeveralGroupsOpenAtTheSameTimeHtml + '" href="#' + randId + '">' + object.title + '</a></h4>' +
                '    </div>' +
                '    <div id="' + randId + '" class="panel-collapse collapse' + isExpandedHtml + '">' +
                '        <div class="panel-body">' +
                '            <div class="panel-body-wrapper">' +
                object.content +
                '            </div>' +
                '        </div>' +
                '    </div>' +
                '</div>';
        }

        var component =
            '<div class="panel-group unify-accordion" id="' + idComponent + '">' +
            componentContent +
            '</div>';
        o.html = component;
        return o;
    }

    /**
    * createBadgeHtml creates html for the badge component
    * @param {object} o options
    * @example createBadgeHtml()
    * @return {{}|undefined} undefined if no component was created or a object where the html is in o.html
    */
    createBadgeHtml(o) {
        o = typeof o === 'undefined' ? {} : o;
        o.text = typeof o.text === 'undefined' ? '' : o.text;
        o.type = typeof o.type === 'undefined' ? '' : o.type;
        var className;

        switch (o.type) {
            case 'active':
                className = 'unify-badge-active';
                break;
            case 'changed':
                className = 'unify-badge-changed';
                break;
            case 'inactive':
                className = 'unify-badge-inactive';
                break;
            case 'new':
                className = 'unify-badge-new';
                break;
            case 'requested':
                className = 'unify-badge-requested';
                break;
            default:
                className = 'unify-badge-active';
        }

        o.html = `<div class="unify-badge ${className}">${o.text}</div>`;
        return o;
    }

    /**
    * createButtonHtml creates html for the button component
    * Size changes height, and width should be fixed with addClass
    * @param {object} o options
    * @example createButtonHtml()
    *          createButtonHtml({height:'lg', width: 'col-sm-4 col-xs-10' });
    * @return {{}|undefined} undefined if no component was created or a object where the html is in o.html
    */
    createButtonHtml(o) {
        o = typeof o === 'undefined' ? {} : o;
        o.text = typeof o.text === 'undefined' ? '' : o.text;
        o.type = typeof o.type === 'undefined' ? '' : o.type;
        o.disabled = typeof o.disabled === 'undefined' ? '' : o.disabled;
        // width and hight are only used in default and primary
        o.width = typeof o.width === 'undefined' ? '' : o.width;
        o.height = typeof o.height === 'undefined' ? '' : o.height;
        o.onclick = typeof o.onclick === 'undefined' ? '' : o.onclick;

        // If o.id is set, use it. If o.id = '' create id, if undefined do not add anything
        var id = typeof o.id === 'undefined' ? '' : ' id="' + o.id + '"';
        if (o.id === '') {
            id = ' id="' + utils.getUniqueComponentId({ prefix: 'button-' }) + '"';
        }

        var className = '';
        switch (o.type) {
            case 'carousel':
                className = 'unify-button-carousel';
                break;
            case 'close':
                className = 'unify-button-close';
                break;
            case 'close-with-label':
                className = 'unify-button-close-with-label';
                break;
            case 'default':
                className = 'btn btn-default';
                break;
            case 'primary':
                className = 'btn btn-primary';
                break;
            case 'secondary':
                className = 'unify-button-secondary';
                break;
            default:
                o.type = 'primary';
                className = 'btn btn-primary';
        }

        var text = '';
        switch (o.type) {
            case 'default':
            case 'primary':
            case 'close-with-label':
            case 'secondary':
                text = o.text;
                break;
            default:
                text = '';
        }

        var width = '';
        var height = '';
        if (o.type === 'primary' || o.type === 'default') {
            width = o.width === '' ? '' : ' ' + o.width;
            switch (o.height) {
                case 'xs':
                    height = ' btn-xs';
                    break;
                case 'sm':
                    height = ' btn-sm';
                    break;
                case 'md':
                    height = ' btn-md';
                    break;
                case 'lg':
                    height = ' btn-lg';
                    break;
                default:
                    height = ' btn-lg';
            }
        }
        var disabled = o.disabled === '' ? '' : ' disabled="disabled"';
        var onclick = o.onclick === '' ? '' : ` onclick="${o.onclick}"`;

        var component;
        switch (o.type) {
            case 'default':
            case 'primary':
                component = `<button${id} class="${className}${width}${height}"${onclick}${disabled}>${text}</button>`;
                break;
            default:
                component = `<button${id} class="${className}"${onclick}${disabled}>${text}</button>`;
        }

        o.html = component;
        return o;
    }

    /**
    * createCheckboxHtml creates html for the checkbox component
    * @param {object} o options
    * @example createCheckboxHtml()
    * @return {{}|undefined} undefined if no component was created or a object where the html is in o.html
    */
    createCheckboxHtml(o) {
        o = typeof o === 'undefined' ? {} : o;
        o.checked = typeof o.checked === 'undefined' ? '' : o.checked;
        o.disabled = typeof o.disabled === 'undefined' ? '' : o.disabled;
        o.id = typeof o.id === 'undefined' ? '' : o.id;
        o.text = typeof o.text === 'undefined' ? '' : o.text;

        var id = o.id;
        if (id === '') {
            o.id = utils.getUniqueComponentId({ prefix: 'checkbox-' });
        }
        var disabled = o.disabled === '' ? '' : ' disabled="disabled"';
        var checked = o.checked === '' || o.checked === false ? '' : ' checked="checked"';

        o.html =
            `<div class="checkbox">
                <input id="${o.id}" class="styled" type="checkbox"${disabled}${checked}>
                <label for="${o.id}">${o.text}</label>
            </div>`;
        return o;
    }

    /**
    * createCheckboxtoggleHtml creates html for the checkboxtoggle component
    * @param {object} o options
    * @example createCheckboxtoggleHtml()
    * @return {{}|undefined} undefined if no component was created or a object where the html is in o.html
    */
    createCheckboxtoggleHtml(o) {
        o = typeof o === 'undefined' ? {} : o;
        o.id = typeof o.id === 'undefined' ? '' : o.id;
        o.text = typeof o.text === 'undefined' ? '' : o.text;
        o.disabled = typeof o.disabled === 'undefined' ? '' : o.disabled;

        var id = o.id;
        if (id === '') {
            o.id = utils.getUniqueComponentId({ prefix: 'checkboxtoggle-' });
        }
        var disabled = o.disabled === '' ? '' : ' disabled="disabled"';

        o.html =
            `<div class="checkbox-toggle">
                <input id="${o.id}" type="checkbox"${disabled}>
                <label for="${o.id}">${o.text}</label>
            </div>`;
        return o;
    }

    /**
    * createDatepickerHtml creates html for the datepicker component
    * @param {object} o options
    * @example createDatepickerHtml()
    * @return {{}|undefined} undefined if no component was created or a object where the html is in o.html
    */
    createDatepickerHtml(o) {
        o = typeof o === 'undefined' ? {} : o;
        o.id = typeof o.id === 'undefined' ? '' : o.id;
        o.placeholder = typeof o.placeholder === 'undefined' ? '' : o.placeholder;
        o.disabled = typeof o.disabled === 'undefined' ? '' : o.disabled;

        var id = o.id;
        if (id === '') {
            o.id = utils.getUniqueComponentId({ prefix: 'datepicker-' });
        }
        var disabled = o.disabled === '' ? '' : ' disabled="disabled"';
        var placeholder = o.placeholder === '' ? '' : ' placeholder="' + o.placeholder + '"';
        o.html =
            `<div id="${o.id}" class="input-group date">
                <input type="text" class="form-control input-lg"${placeholder}${disabled}>
                <span class="input-group-addon"><img class="unify-svg" src="/lib/Unify/images/calendar.svg"></span>
            </div>`;
        return o;
    }

    /**
    * createDialogHtml creates html for the dialog component
    * @param {object} o options
    * @example createDialogHtml()
    * @return {{}|undefined} undefined if no component was created (with console message) or a object where the html is in o.html
    */
    createDialogHtml(o) {
        // if o is not set, create one
        o = typeof o === 'undefined' ? {} : o;
        o.title = typeof o.title === 'undefined' ? '' : o.title;
        o.body = typeof o.body === 'undefined' ? 'body' : o.body;
        o.footer = typeof o.footer === 'undefined' ? '<button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button><button type="button" class="btn btn-primary">Ok</button>' : o.footer;
        o.okText = typeof o.okText === 'undefined' ? '' : o.okText;
        o.cancelText = typeof o.cancelText === 'undefined' ? '' : o.cancelText;
        o.closeText = typeof o.closeText === 'undefined' ? '' : o.closeText;
        o.content = typeof o.content === 'undefined' ? '' : o.content;
        o.id = typeof o.id === 'undefined' ? '' : o.id;
        o.showModalButtonText = typeof o.showModalButtonText === 'undefined' ? 'showModal' : o.showModalButtonText;
        o.tabIndex = typeof o.tabIndex === 'undefined' ? 'tabindex="-1"' : o.tabIndex;
        o.showHeaderCloseButton = typeof o.showHeaderCloseButton === 'undefined' ? true : o.showHeaderCloseButton;
        o.addClass = typeof o.addClass === 'undefined' ? 'unify-modal' : 'unify-modal ' + o.addClass;
        // replace the footer text if ok text is given
        if (o.okText !== '') {
            o.footer.replace('Ok', o.okText);
        }
        // replace the footer text if cancel text is given
        if (o.cancelText !== '') {
            o.footer.replace('Cancel', o.cancelText);
        }

        var headerCloseButtonHtml = o.closeText === '' ? '<button type="button" class="unify-button-close pull-right" data-dismiss="modal" aria-label="Close"></button>' :
            `<button type="button" class="unify-button-close visible-xs pull-right" data-dismiss="modal" aria-label="Close"></button>
             <button type="button" class="unify-button-close-with-label hidden-xs pull-right" data-dismiss="modal" aria-label="Close">${o.closeText}</button>`;
        if (o.showHeaderCloseButton === false) {
            headerCloseButtonHtml = '';
        }

        // create id for the component if not given
        if (o.id === '') {
            o.id = utils.getUniqueComponentId({ prefix: 'modal-' });
        }

        // create id for the header (expose it?)
        var titleId = utils.getUniqueComponentId({ prefix: 'modal-title-' });

        if (o.body === '') {
            console.log('createDialogHtml: called without body, return undefined', o);
            return undefined;
        }
        var footerHtml = '';
        if (o.footer !== '') {
            footerHtml = `<div class="modal-footer">${o.footer}</div>`;
        }

        var component =
            `<div class="modal fade ${o.addClass}" id="${o.id}" ${o.tabIndex} role="dialog" aria-labelledby="myModalLabel">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            ${headerCloseButtonHtml}
                            <h4 class="modal-title" id="${titleId}">${o.title}</h4>
                        </div>
                        <div class="modal-body">
                            ${o.body}
                        </div>
                        ${footerHtml}
                    </div>
                </div>
            </div>`;

        // create the button html
        o.showDialogButtonHtml = `<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#${o.id}">${o.showModalButtonText}</button>`;
        o.html = component;
        return o;
    }

    /**
    * createFoldoutHtml creates html for the foldout component
    * @param {object} o options
    * @example createFoldoutHtml()
    *          with popover
    *          1. createFoldoutHtml({popover: '<span data-container="body" data-html="true" data-placement="bottom" data-toggle="popover" data-content="SOMEHTML" onclick="window.unify.stopBubbling(event);"><i class="fa fa-question-circle"></i></span>'})
    *          2. add $(function() {$('[data-toggle="popover"]').popover();}) to page
    * @return {{}|undefined} undefined if no component was created or a object where the html is in o.html
    */
    createFoldoutHtml(o) {
        o = typeof o === 'undefined' ? {} : o;
        o.content = typeof o.content === 'undefined' ? '' : o.content;
        o.disableCollapse = typeof o.disableCollapse === 'undefined' ? '' : o.disableCollapse;
        o.popover = typeof o.popover === 'undefined' ? '' : o.popover;
        o.startCollapsed = typeof o.startCollapsed === 'undefined' ? '' : o.startCollapsed;
        o.title = typeof o.title === 'undefined' ? '' : o.title;

        var disableCollapse = '';
        if (o.disableCollapse !== '') {
            disableCollapse = ' foldout-disable-collapse';
        }

        var startCollapsed = '';
        if (o.disableCollapse === '' && o.startCollapsed !== '') {
            startCollapsed = ' foldout-item-collapsed';
        }

        o.html =
            `<div class="foldout-item${startCollapsed}">
                <div class="foldout-title${disableCollapse}">
                    <h5>${o.title}</h5>
                    <div class="foldout-tools">
                        ${o.popover}
                        <a class="collapse-link"><i class="sp"></i></a>
                    </div>
                </div>
                <div class="foldout-content">
                    <div class="row">
                        <div class="col-xs-12">
                            ${o.content}
                        </div>
                    </div>
                </div>
            </div>`;
        return o;
    }

    /**
    * createInputHtml creates html for a form input component
    * @param {object} o where o is object with optional label, id and type parameters
    * @example createInputHtml()
    * @return {{}} where the object html exist in o.html
    */
    createInputHtml(o) {
        // if o is not set, create one
        o = typeof o === 'undefined' ? {} : o;
        o.feedback = typeof o.feedback === 'undefined' ? '' : o.feedback;
        o.height = typeof o.height === 'undefined' ? '' : o.height;
        o.id = typeof o.id === 'undefined' ? '' : o.id;
        o.label = typeof o.label === 'undefined' ? '' : o.label;
        o.placeholder = typeof o.placeholder === 'undefined' ? '' : o.placeholder;
        o.type = typeof o.type === 'undefined' ? 'text' : o.type;

        // create id for the component if not given
        if (o.id === '') {
            o.id = utils.getUniqueComponentId({ prefix: 'form-input-' });
        }

        var height;
        switch (o.height) {
            case 'sm':
                height = ' input-sm';
                break;
            case 'md':
                height = '';
                break;
            case 'lg':
                height = ' input-lg';
                break;
            default:
                height = '';
        }

        var placeholder = o.placeholder !== '' ? ' placeholder="' + o.placeholder + '"' : '';
        var feedback = o.feedback !== '' ? '<span class="form-control-feedback">' + o.feedback + '</span>' : '';
        var hasFeedback = feedback !== '' ? ' has-feedback' : '';

        var component =
            `<div class="form-group${hasFeedback}">
               <label for="${o.id}" class="form-control-label">${o.label}</label>
               <input class="form-control${height}" id="${o.id}" name="${o.id}" type="${o.type}" value=""${placeholder}>
               ${feedback}
            </div>`;

        o.html = component;
        return o;
    }

    /**
    * createRadiobuttonHtml creates html for the radiobutton component
    * Name is posted and should be shared in a radio group.
    * @param {object} o options
    * @example createRadiobuttonHtml()
    * @return {{}|undefined} undefined if no component was created (with console message) or a object where the html is in o.html
    */
    createRadiobuttonHtml(o) {
        o = typeof o === 'undefined' ? {} : o;
        o.checked = typeof o.checked === 'undefined' ? '' : o.checked;
        o.disabled = typeof o.disabled === 'undefined' ? '' : o.disabled;
        o.id = typeof o.id === 'undefined' ? '' : o.id;
        o.name = typeof o.name === 'undefined' ? '' : o.name;
        o.text = typeof o.text === 'undefined' ? '' : o.text;
        o.value = typeof o.value === 'undefined' ? '' : o.value;

        if (o.name === '') {
            console.log('createRadiobuttonHtml: called without name, return undefined', o);
            return undefined;
        }

        if (o.value === '') {
            console.log('createRadiobuttonHtml: called without value, return undefined', o);
            return undefined;
        }

        if (o.id === '') {
            o.id = utils.getUniqueComponentId({ prefix: 'radiobutton-' });
        }

        var checked = o.checked === '' ? '' : ' checked="checked"';
        var disabled = '';
        if (o.disabled !== '') {
            disabled = ' disabled="disabled"';
            checked = '';
        }

        o.html =
            `<div class="radio">
                <input type="radio" name="${o.name}" id="${o.id}" value="${o.value}"${checked}${disabled}>
                <label for="${o.id}">${o.text}</label>
            </div>`;
        return o;
    }

    /**
    * createSearchHtml creates html for the search component
    * @param {object} o options
    * @example createSearchHtml()
    * @return {{}|undefined} undefined if no component was created (with console message) or a object where the html is in o.html
    */
    createSearchHtml(o) {
        o = typeof o === 'undefined' ? {} : o;
        o.addClearButton = typeof o.addClearButton === 'undefined' ? '' : o.addClearButton;
        o.disabled = typeof o.disabled === 'undefined' ? '' : o.disabled;
        o.id = typeof o.id === 'undefined' ? '' : o.id;
        o.name = typeof o.name === 'undefined' ? '' : o.name;
        o.placeholder = typeof o.placeholder === 'undefined' ? '' : o.placeholder;
        o.value = typeof o.value === 'undefined' ? '' : o.value;

        // If o.id is set, use it. If o.id = '' create id, if undefined do not add anything
        var id = typeof o.id === 'undefined' ? '' : ' id="' + o.id + '"';
        if (o.id === '') {
            id = ' id="' + utils.getUniqueComponentId({ prefix: 'search-' }) + '"';
        }

        var disabled = '';
        if (o.disabled !== '') {
            disabled = ' disabled="disabled"';
        }

        var name = '';
        if (o.name !== '') {
            name = ` name="${o.name}"`;
        }

        var placeholder = '';
        if (o.placeholder !== '') {
            placeholder = ` placeholder="${o.placeholder}"`;
        }

        var value = '';
        if (o.value !== '') {
            value = ` value="${o.value}"`;
        }

        var clearButton = '';
        var showClearButtonFromStart = '';
        if (o.addClearButton !== '') {
            clearButton = `<button class="unify-button-close"></button>`;
            // clear button will be shown when value changed
            // if has value from start and not disabled show the button from start
            if (o.disabled === '' && value !== '') {
                showClearButtonFromStart = ' unify-dirty';
            }
        }


        o.html =
            `<div class="form-group unify-search${showClearButtonFromStart}">
                <input ${id}${name}${placeholder}${value}${disabled} type="text" class="input-lg">
                ${clearButton}
            </div>`;
        return o;
    }

    /**
    * createSelectivityHtml creates html for a select
    * @param {object} o, where o is object with optional label, id and type parameters
    * @example createSelectivitytHtml({items:[ {value:'1', text:'text1'},{value:'2', text:'text2'} ]})
    * @return {{}|undefined} undefined if no options was given (with console message) or a object where the html and script to be added to the page is in the is in o.html
    */
    createSelectivityHtml(o) {
        // if o is not set, create one
        o = typeof o === 'undefined' ? {} : o;
        o.config = typeof o.config === 'undefined' ? {} : o.config;
        o.height = typeof o.height === 'undefined' ? '' : o.height;
        o.id = typeof o.id === 'undefined' ? '' : o.id;
        o.items = typeof o.items === 'undefined' ? '' : o.items;
        o.label = typeof o.label === 'undefined' ? '' : o.label;
        o.width = typeof o.width === 'undefined' ? "100%" : o.width;

        if (o.items === '' && typeof o.config.items !== 'undefined') {
            console.log('createSelectHtml: called without items, return undefined', o);
            return undefined;
        }

        // create id for the component if not given
        if (o.id === '') {
            o.id = utils.getUniqueComponentId({ prefix: 'select-' });
        }

        var component = `<div id="${o.id}"></div>`;
        if (typeof o.config.items === 'undefined') {
            var items = [];
            for (var i = 0, nr = o.items.length; i < nr; i++) {
                var item = o.items[i];
                items.push({ id: item.value, text: item.text });
            }
            o.config.items = items;
        }

        // use o.width if not specified in o.config
        if (typeof o.config.width === 'undefined' && typeof o.width !== 'undefined') {
            o.config.width = o.width;
        }

        // optional label
        if (o.label !== '') {
            component =
                `<div class="form-group">
                   <label for="${o.id}" class="form-control-label">${o.label}</label>
                   ${component}
                </div>`;
        }
        var inputType = '';
        if (typeof o.config.inputType !== 'undefined') {
            inputType = o.config.inputType.toLowerCase();
        }
        var shouldAddHeight = inputType === 'unifysingle' || inputType === 'unifymultiple';
        // selectivity has no code for adding class to main object, only to dropdown
        // the class to modify the height are neede to be on the enclosing div, so we add it after initi
        var height = '';
        if (shouldAddHeight) {
            switch (o.height) {
                case 'sm':
                    height = inputType === 'unifysingle' ? `$('#${o.id}').addClass("unify-select-single-sm");` : `$('#${o.id}').addClass("unify-select-multiple-sm");`;
                    break;
                case 'md':
                    height = inputType === 'unifysingle' ? `$('#${o.id}').addClass("unify-select-single-md");` : `$('#${o.id}').addClass("unify-select-multiple-md");`;
                    break;
                case 'lg':
                    height = inputType === 'unifysingle' ? `$('#${o.id}').addClass("unify-select-single-lg");` : `$('#${o.id}').addClass("unify-select-multiple-lg");`;
                    break;
                default:
                    height = '';
            }
        }
        var config = JSON.stringify(o.config);
        // script that activates the select
        var script = `<script>$('#${o.id}').selectivity(${config});${height}</script>`;
        o.html = component + script;

        return o;
    }

    /**
    * createSelectHtml creates html for a select
    * @param {object} o where o is object with optional label, id and type parameters
    * @example createSelectHtml({options:[ {value:'1', text:'text1'},{value:'2', text:'text2'} ]})
    * @return {{}|undefined} undefined if no options was given (with console message) or a object where the html and script to be added to the page is in the is in o.html
    */
    createSelectHtml(o) {
        // if o is not set, create one
        o = typeof o === 'undefined' ? {} : o;
        o.id = typeof o.id === 'undefined' ? '' : o.id;
        o.label = typeof o.label === 'undefined' ? '' : o.label;
        o.options = typeof o.options === 'undefined' ? '' : o.options;
        o.config = typeof o.config === 'undefined' ? '{ width: "100%" }' : o.config;

        if (o.options === '') {
            console.log('createSelectHtml: called without options, return undefined', o);
            return undefined;
        }

        // create id for the component if not given
        if (o.id === '') {
            o.id = utils.getUniqueComponentId({ prefix: 'select-' });
        }

        var component = '<select id="' + o.id + '">';
        for (var i = 0, nr = o.options.length; i < nr; i++) {
            var option = o.options[i];
            var disabledHtml = typeof option.disabled !== "undefined" ? ' disabled=""' : '';
            component += '<option value="' + option.value + disabledHtml + '">' + option.text + '</option>';
        }
        component += '</select>';
        // optional label
        if (o.label !== '') {
            component =
                '<div class="form-group">' +
                '   <label for="' + o.id + '" class="form-control-label">' + o.label + '</label>' +
                component +
                '</div>';
        }
        // script that activates the select
        var script = '<script>$(\'#' + o.id + '\').select2(' + o.config + ');</script>';
        o.html = component + script;
        return o;
    }

    /**
    * createSidebarHtml creates html for the sidebar component
    * @param {object} o options
    * @example createSidebarHtml()
    * @return {{}|undefined} undefined if no component was created or a object where the html is in o.html
    */
    createSidebarHtml(o) {
        o = typeof o === 'undefined' ? {} : o;
        o.text = typeof o.text === 'undefined' ? '' : o.text;
        o.width = typeof o.width === 'undefined' ? '' : o.width;
        var width = o.width === '' ? '' : ' ' + o.width;
        o.html = `<div class="unify-sidebar${width}">${o.text}</div>`;
        return o;
    }
}